var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCommunication = function SvgCommunication(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 70 70"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#communication_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#B4CFFF",
    fillRule: "evenodd",
    d: "M16 2a2 2 0 0 1 2-2h15a2 2 0 0 1 2 2v9h-4a2 2 0 0 0-2 2v6H18a2 2 0 0 1-2-2zm15.73 4.565a1 1 0 0 0-1.415-1.414l-6.457 6.457-3.15-3.15a1 1 0 1 0-1.415 1.414l3.858 3.858a1 1 0 0 0 1.414 0z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 36.069,
    height: 24.046,
    x: 29,
    y: 11,
    fill: "#FFD2A8",
    rx: 2
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF9D43",
    fillRule: "evenodd",
    d: "M48.178 24.23a2 2 0 0 1-2.287 0l-15.2-10.59c-.841-.587-1.024-1.56-.726-2.352-.578.35-.965.986-.965 1.712v20.046a2 2 0 0 0 2 2h32.069a2 2 0 0 0 2-2V13c0-.726-.387-1.361-.966-1.712.299.793.116 1.765-.726 2.351z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6C9BF1",
    fillRule: "evenodd",
    d: "M13 51.36V42a2 2 0 0 1 2-2h25.566v9.36a2 2 0 0 1-2 2zm0 2.683.591-.683h24.975a4 4 0 0 0 4-4V40h4.998a2 2 0 0 1 2 2v16.4l.002.09v9.526c0 1.852-2.3 2.71-3.512 1.31l-5.166-5.966H15a2 2 0 0 1-2-2z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2F68D1",
    fillRule: "evenodd",
    d: "M38.566 28a2 2 0 0 1 2 2v19.36a2 2 0 0 1-2 2H12.678l-5.166 5.965C6.3 58.725 4 57.868 4 56.016V46.49q0-.045.002-.09V30a2 2 0 0 1 2-2z",
    clipRule: "evenodd"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "communication_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h70v70H0z"
  })))));
};
export default SvgCommunication;